import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Card, Col, Form, Input, InputNumber, message, Row, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { customerCategoryService } from "../../../services/customer-category.service";
import { cubicationCostService } from "../../../services/cubication-cost.service";

export default function CubicationCostForm(){

  const { id } = useParams()

  const [form] = useForm()
  const navigate = useNavigate()

  const queryClient = useQueryClient();

  const { data: faq  } = useQuery({
    queryKey: ['detailCubicationCost', id],
    queryFn: () => cubicationCostService.getById(id),
    enabled: !!id
  })

  const { data: customerCategories } = useQuery({
    queryKey: ['customerCategories'],
    queryFn: () => customerCategoryService.fetchAllWithoutPaginate()
  })

  useEffect(() => {
    if(id){
      form.setFieldsValue(faq?.data)
    }

  }, [faq, form, id])

  const storeMutation = useMutation({
    mutationFn: (data) => cubicationCostService.store(data),
    onSuccess: () => {
      queryClient.invalidateQueries('users');
      message.success('Data berhasil disimpan');
      form.resetFields();
      navigate('/bill-simulation/cubication-cost')
    },
    onError: (error) => {
      console.log(error)
      message.error('Terjadi Kesalahan');
    }
  })

  const updateMutation = useMutation({
    mutationFn: (data) => cubicationCostService.update(data),
    onSuccess: () => {
      queryClient.invalidateQueries('users');
      message.success('Data berhasil diubah');
      form.resetFields();
      navigate('/bill-simulation/cubication-cost')
    },
    onError: (error) => {
      console.log(error)
      message.error('Terjadi Kesalahan');
    }
  })

  const handleSubmit = (val) => {
    if(!id) storeMutation.mutate(val)
    else updateMutation.mutate(val)
  }

  return (
    <>
      <Card
        title={ (id ? "Ubah" : "Tambah") + " Data"}
        actions={[
          <CardFooterAction
            key={'1'}
            route={'/bill-simulation/cubication-cost'}
            onClick={() => form.submit()}
          />
        ]}
      >
        <Form
          layout="vertical"
          form={form}
          onFinish={handleSubmit}
        >
          <Form.Item hidden name={'id'} >
            <Input/>
          </Form.Item>
          <Form.Item
            name={'CustomerCategoryId'}
            label="Kategori Pelanggan"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Select
              options={customerCategories?.data?.map(e => ({ value: e.id, label: e.name }))}
            />
          </Form.Item>
          <Row gutter={[20]} >
            <Col span={4} >
              <Form.Item
                name={'code'}
                label="Kode Tarif"
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <Input/>
              </Form.Item>
            </Col>
            <Col span={20} >
              <Form.Item
                name={'name'}
                label="Jenis Pelanggan"
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <Input/>
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item
                name={'bind_1'}
                label="0 m3 sd 10 m3"
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item
                name={'bind_2'}
                label="11 m3 sd 20 m3"
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
            <Col span={8} >
              <Form.Item
                name={'bind_3'}
                label="> 21 m3"
                rules={[
                  {
                    required: true
                  }
                ]}
              >
                <InputNumber style={{ width: '100%' }} />
              </Form.Item>
            </Col>
          </Row>
          
        </Form>
      </Card>
    </>
  )
}